import { render, staticRenderFns } from "./EditUserStaff.vue?vue&type=template&id=742cf9a0&"
import script from "./EditUserStaff.vue?vue&type=script&lang=js&"
export * from "./EditUserStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports